<template>
  <component
    :is="icon"
    ref="rootElement"
    :class="colorClass"
    :data-test="dataTest"
    :style="style" />
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, ref, Ref, shallowRef, watch } from 'vue'

interface Props {
  colorClass?: string
  iconName: string,
  remSize?: number,
}
const props = withDefaults(defineProps<Props>(), {
  colorClass: 'tw-fill-core-primary-50',
  remSize: 1.5,
})

const rootElement = ref<HTMLElement | null>(null)

type Emits = (e: 'click', event: Event) => void

const emit = defineEmits<Emits>()

const dataTest = computed(() => `svg-icon-${props.iconName}`)
const style = computed(() => {
  const size = `${props.remSize}rem`
  return {
    height: size,
    width: size,
    'min-height': size,
    'max-height': size,
    'min-width': size,
    'max-width': size,
  }
})

watch(
  () => rootElement.value,
  () => {
    if (rootElement.value !== null) {
      rootElement.value.$el.onclick = (e: Event) => emit('click', e)
    }
  }
)

// Type is unknown because of the different typing of defineAsyncComponent between vue 2 and vue3
const icon: Ref<unknown | null> = shallowRef(null)

watch(
  () => props.iconName,
  () => {
    icon.value = defineAsyncComponent(() => import(`frontcore/assets/icons/Icon${props.iconName}.vue`))
  },
  { immediate: true }
)
</script>
